import { PrimaryButton } from "@graffer-inc/console-design-kit";

type Props = {
  hiddenSelectYYYYMM: boolean;
  buttonText: string;
  isLoading: boolean;
  terms: string[];
  targetYYYYMM: string;
  setTargetYYYYMM: (value: string) => void;
  onDownload: (yyyymm: string) => Promise<void>;
};

export const PaymentRawdataCSVDownloader = ({
  hiddenSelectYYYYMM,
  buttonText,
  isLoading,
  terms,
  targetYYYYMM,
  setTargetYYYYMM,
  onDownload,
}: Props) => {
  return (
    <div className="columns">
      {!hiddenSelectYYYYMM && (
        <div className="column is-narrow">
          <div className="control">
            <div className="select is-fullwidth">
              <select
                onChange={(e) => setTargetYYYYMM(e.currentTarget.value)}
                value={targetYYYYMM}
              >
                <option value="" />
                {terms.map((v) => (
                  <option key={v} value={v.replace("-", "")}>
                    {v.replace(/(\d{4})(\d{2})/g, "$1年$2月")}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {terms.length === 0 && (
            <p className="help is-danger">データがありません</p>
          )}
        </div>
      )}
      <div className="column">
        <PrimaryButton
          text={buttonText}
          onClick={async (e) => {
            e.preventDefault();
            await onDownload(targetYYYYMM);
          }}
          disabled={isLoading || targetYYYYMM === ""}
        />
      </div>
    </div>
  );
};
